import React from 'react';
import ReactDOM from 'react-dom';
import "typeface-open-sans";
import './index.css';
import './shared/Icons.css';
import ClientApp from './ClientApp';

import URLSearchParams from 'url-search-params';

import values from 'object.values';

import openSocket from 'socket.io-client';
import webrtcAdapter from 'webrtc-adapter';

import { IntlProvider, addLocaleData } from 'react-intl';
import de from 'react-intl/locale-data/de';
import fr from 'react-intl/locale-data/fr';
import it from 'react-intl/locale-data/it';

import messages_de from './shared/translations/messages_de.json';
import messages_fr from './shared/translations/messages_fr.json';
import messages_it from './shared/translations/messages_it.json';

const localeData = {
  de: messages_de,
  fr: messages_fr,
  it: messages_it
}

addLocaleData([...de, ...fr, ...it]);

let setting = window.localStorage ? window.localStorage.getItem('language') : null;
let language = (navigator.languages && navigator.languages[0]) ||
                     navigator.language ||
                     navigator.userLanguage;
let languageWithoutRegionCode = language.toLowerCase().split(/[_-]+/)[0];

const messages = localeData[setting] || localeData[languageWithoutRegionCode] || localeData[language] || localeData.de;

if (!Object.values) {
	values.shim();
}

const socket = openSocket('https://ms-comm.z4butrwhlxv8.nooon.io:443', {
  rememberTransport: true, 
  'reconnection': true,
  'reconnectionDelay': 500,
  'secure': true
});

// const socket = openSocket('https://localhost:443');
const params = new URLSearchParams(document.location.search);
let locale = setting||languageWithoutRegionCode||'de';

ReactDOM.render(
  <IntlProvider locale={locale} messages={messages}>
    <ClientApp
      locale={locale}
      socket={socket}
      user={params.get('u')}
      appointment={params.get('a') ? new Date(parseInt(params.get('a'))) : null}
    />
  </IntlProvider>,
document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js